<template>
    <div>
        <Header title="公海">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                        <Input prefix="ios-search" v-model="search_name" placeholder="请输入用户姓名" style="width:240px;"></Input>
                        <TagScreen @changeTags="changeTag" ></TagScreen>
                        <Button type="warning" @click="searchList" style="margin-left:10px">搜索</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading"  :size="table.limit"  :columns="table.columns" :data="table.data" :current="table.current" :total="table.total"   @switchPage="changepage" >
            </PageTable>
        </div>


        <Modal
                :mask-closable="false"
                v-model="show_claim"
                title="认领"
                width="400">
            <div class="my-modal-del">
                <Icon type="ios-help-circle" style="font-size:40px;color:#ff0000; " />
                确认要认领该客户？
            </div>
            <div slot="footer">
                <Button  type="primary"  @click="claim_customer">确定</Button >
            </div>
        </Modal>

        <Modal
                v-model="show_follow"
                title="跟进状态"
                width="900"
                :mask-closable="false"
        >

            <PageTable :loading="follow_table.loading" :size="follow_table.limit"  :columns="follow_table.columns" :data="follow_table.data" :current="follow_table.current" :total="follow_table.total" @switchPage="change_record"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>
    </div>

</template>
<script>
import { follow_record_list} from  "@/api/customer"
import {waters_list, claim_customer} from  "@/api/order"
    import {Header, PageTable, TagScreen} from "@/components/mainLayout"
import {copyText} from "@/utils/helper";
    export default {
        components:{
            Header,
            PageTable,
            TagScreen
        },
        data(){
            return{
                screen_tags_text:"",
                show_follow:false,
                search_name:"",
                show_claim:false,
                order_id:"",
                follow_table: {
                    loading:false,
                    current: 1,
                    total: 0,
                    limit: 30,
                    columns: [
                        {
                            type:'index',
                            width:'80',
                            align:'center'
                        },{
                            title: '跟进时间',
                            align:'center',
                            width:'200',
                            key: 'follow_time'
                        },{
                            title: '状态',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                console.log(params.row)
                                let status_name = params.row.follow_type == 1 ? "首次跟进" : `第`+params.row.follow_type+`次跟进`;
                                return h('div', [
                                    h('span', {}, status_name)
                                ]);

                            }
                        },{
                            title: '图片',
                            align:'center',
                            key: 'ctime',
                            render: (h, params) => {
                                let img_arr = [];
                                for (let i in params.row.follow_img) {
                                    img_arr.push(params.row.follow_img[i].url)
                                }
                                if(img_arr.length > 0){
                                    return h('div', img_arr.map(img=>{ //循环显示
                                            return h('img',  {
                                                attrs: {
                                                    src: img,
                                                    style: 'width: 30px;height: 30px;cursor:pointer'
                                                },
                                                on:{
                                                    click:()=>{
                                                        let content = '<img src="'+img+'" style="width:100%;height:100%" />';
                                                        this.$Modal.info({
                                                            title: "预览",
                                                            content: content
                                                        });
                                                        console.log(img)
                                                    }
                                                }
                                            },);
                                        })
                                    )
                                }else{
                                    return h("span", '');
                                }

                            }
                        },{
                            title: '备注',
                            align:'center',
                            key: 'note',
                            render: (h, params) => {
                                return h('Input',{
                                    props: {
                                        value:params.row.note,
                                        type:'textarea'
                                    }
                                })
                            }
                        },{
                            title: '负责人员',
                            align:'center',
                            key: 'responsible_name'
                        }],
                    data:[]
                },
                table:{
                    current:1,
                    total:50,
                    loading:false,
                    columns: [
                        {
                            title: '单号',
                            width:'120',
                            align:'center',
                            key: 'id'
                        },
                        {
                            title: '客户',
                            align:'center',
                            width:'300',
                            key: 'name',
                            render: (h, params) => {
                                let male = require("../../assets/11.png");
                                let female = require("../../assets/12.png");
                                let default_img = require("../../assets/3.png");
                                if (params.row.avatar != null && params.row.avatar != "") {
                                    default_img = params.row.avatar
                                }
                                let default_ = female;
                                if (params.row.gender == 1) {
                                    default_ = male;
                                }
                                if (params.row.is_big == 1) {
                                    var default_big = require("@/assets/is_big.png");
                                }
                                return h("div", {
                                    domProps:{
                                        innerHTML:
                                            `<div style="display: flex;padding:10px 0 5px;height: 100px;cursor:pointer">`+
                                                `<img src=`+default_img+` style="width:50px;height:50px;">` +
                                                `<div style="margin-left:10px;flex:1;text-align: left;">` +
                                                    `<div>`+(params.row.remark || params.row.customer_name)+`</div>`+
                                                    `<div><img src=`+default_+` style="width:20px;height:20px;"><img src=`+default_big+` style="width:32px;height:10.5px;">`+`</div>`+
                                                `</div>` +
                                            `</div>`
                                    },
                                    on:{
                                        click:()=>{
                                            copyText(params.row.remark || params.row.customer_name)
                                        }
                                    }
                                })

                            }
                        },
                        {
                            title: '标签',
                            align:'center',
                            key: 'id',
                            width:300,
                            render: (h,params) => {
                                let tpl = "", tag_name = params.row.tag_name;
                                if (tag_name && tag_name.length > 0) {
                                    for(let i in tag_name) {
                                        tpl += `<div><div  class="tag-class">`+tag_name[i]+`</div></div>`;
                                    }
                                } else {
                                    tpl += `<div class="tag-dotted">尚未设置</div>`;
                                }
                                return h("div", {
                                    domProps:{
                                        innerHTML:`<div style="display:flex;flex-wrap:wrap;padding:10px 0 5px">`+
                                            tpl +
                                            `</div>`
                                    }
                                })

                            }
                        },
                        {
                            title: '行业',
                            align:'center',
                            key: 'industry_id',
                            width:150,
                            render: (h, params) => {
                                let industry_name = params.row.industryName ? params.row.industryName : "暂未设置"
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, industry_name)
                                ]);
                            }
                        },
                        {
                            title: '跟进状态',
                            align:'center',
                            key: 'id',
                            width:200,
                            render: (h, params) => {

                                let status_name = params.row.followStatus == 1 ? "首次跟进" :  params.row.followStatus == 0 ? '尚未跟进':`第`+params.row.followStatus+`次跟进`;

                                return h('div', [
                                    h('span', {
                                        style:{color:'#3F8CFF', cursor:'pointer'},
                                        on: {
                                            click: () => {
                                                this.order_id = params.row.id;
                                                this.show_follow = true;
                                                this.record_list();
                                            }
                                        }
                                    }, status_name)
                                ]);
                            }
                        },
                        {
                            title: '跟进员工',
                            align:'center',
                            key: 'ctime',
                            width:200,
                            render: (h, params) => {
                                let department_member_name = params.row.department_member_name ? params.row.department_member_name : "暂无"
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, department_member_name)
                                ]);

                            }
                        },
                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            fixed: 'right',
                            width:140,
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.order_id = params.row.id
                                                this.show_claim = true;
                                            }
                                        }
                                    }, '认领')
                                    ,h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.$router.push({
                                                    path: '/customerpool/info',
                                                    query: {
                                                        order_id: params.row.id,
                                                        customer_id:params.row.customerId,
                                                        type:5
                                                    }
                                                });
                                            }
                                        }
                                    }, '详情')
                                ]);

                            }

                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.getList();
        },
        methods:{
            searchList(){
                this.table.current = 1
                this.getList()
            },
            changeTag(e){
                this.screen_tags_text = e;
            },
            getList(){
                let val = {limit:this.table.limit, page:this.table.current};
                if(this.search_name != "") {
                    val.search_name = this.search_name
                }

                if (this.screen_tags_text != "")  {
                    val.screen_tags_text = this.screen_tags_text
                }
                this.table.loading = true;
                waters_list(val).then(res=>{
                    this.table.loading = false;
                    if(res.code == 200) {
                        this.table.data = res.data;
                        this.table.total = res.total;
                    } else {
                        this.table.data = [];
                        this.table.total = 0;
                        this.$Message.error(res.msg)
                    }
                })
            },
            claim_customer(){

                this.$Message.info({
                    content: '认领中',
                    duration: 0
                });
                this.show_claim = false;
                claim_customer({id:this.order_id}).then(res=>{
                    this.$Message.destroy()
                    if(res.code == 200) {
                        this.getList();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            changepage(e){
                this.table.current = e;
                this.getList();
            },
            // 查询跟进记录
            record_list(){
                this.follow_table.loading = true;
                follow_record_list({order_id:this.order_id, limit:this.follow_table.limit, page:this.follow_table.current}).then(res=>{
                    this.follow_table.loading = false;
                    if (res.code == 200) {
                        this.follow_table.data = res.data;
                        this.follow_table.total = res.total;
                    } else {
                        this.follow_table.data = [];
                        this.follow_table.total = 0;
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 跟进记录换页
            change_record(e){
                this.follow_table.current = e;
                this.record_list();
            },
            delete_order(){
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否删除该订单？</p>',
                    onOk: () => {
                        order_delete({order_id:this.order_id}).then(res=>{
                            if (res.code == 200) {
                                this.getList()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            }
        }
    }
</script>
<style scoped>

    >>>.tag-class{
        width: 90%;
        padding:5px 10px;
        border:1px solid #ddd;
        border-radius: 5px;
        margin:2px 5px;
        background: #ffffff;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }

    >>>.tag-dotted{

        width: 90%;
        padding:5px 10px;
        border:1px dotted #ddd;
        border-radius: 5px;
        margin:2px 5px;
    }

</style>
